import Vue from 'vue'

// axios
import axios from 'axios'
import { appVersion } from '../../package.json'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_API_URL,
  // timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
    // 사용자 API 호출 시 package.json의 appVersion을 헤더에 포함하여 버전 라우팅 시 사용
    // package.json을 통해 설정되는 값은 관리자에서 미리보기 등의 사유로 직접 브라우저를 띄운 경우에만 유효하며,
    // 일반적으로 닥터인포 앱을 통해 구동 시에는 앱 실행버전으로 덮어 씌어짐
    'app-version': appVersion,
  },
})

Vue.prototype.$http = axiosIns

export default axiosIns
